import { TopbarTabs } from './TopbarTabs';
import { Grid } from '@mui/material';
import header from './goldhintbanner.jpg';
import { useSearchParams } from 'react-router-dom';

function App() {
    const [searchParmas] = useSearchParams();
    return (
        <Grid>
            <img style={{ width: '100%', maxHeight: '200px', objectFit: 'cover' }} src={header} alt="Save the Date" />
            <div className="bgcwcontainer">
                <div className="bgcw">
                    BG
                    <div style={{ margin: '5px' }}>&</div>
                    CW
                </div>
            </div>

            <Grid container justifyContent="center">
                <TopbarTabs />
            </Grid>
        </Grid>
    );
}

export default App;
